// A named import, so esbuild bundles the answers and not the file's _meta
// note (top-level JSON keys tree-shake; a default import keeps them all).
import { items } from '../../../seo/good_to_know.json'

// The four answers every page shares (be home, where the car goes, rain, the
// price): seo/good_to_know.json, the one copy. /faqs and the home page's
// Quick answers read it here; SeoHelper::FAQ and the wash pages read the same
// file on the server (GoodToKnow). Edit the JSON, never a page.

export const GOOD_TO_KNOW = items

// The items a surface ('home', 'wash_pages') shows, in file order: the ones
// whose `hidden_on` does not name it (be home is off the home page, 25 Oct
// 2026; /faqs picks its answers by id).
export const goodToKnowFor = surface =>
  items.filter(entry => !(entry.hidden_on || []).includes(surface))

export const goodToKnow = id => {
  const item = items.find(entry => entry.id === id)
  if (!item) throw new Error(`no good-to-know answer ${id}`)
  return item
}

// [before, link words, after]: the answer cut around the words its `link`
// names, so a page can put a link on them. No link: [answer, null, ''].
export const splitAnswer = item => {
  const words = item.link && item.link.text
  const at = words ? item.a.indexOf(words) : -1
  if (at < 0) return [item.a, null, '']
  return [item.a.slice(0, at), words, item.a.slice(at + words.length)]
}
